import { useActiveStation } from '../../../../../core/stations/hooks/useActiveStation';
import { YoutubeRecentBroadcasts } from '../youtube/broadcasts/recent/YoutubeRecentBroadcasts';
import { NoSegmentsMessage } from './NoSegmentsMessage';

/**
 * Empty stream state factory: shows recent YouTube Native transmissions when the
 * station is offline, or the default no-segments message otherwise.
 */
export function NoStreamMessage() {
  const station = useActiveStation();

  if (station.youtubeNative) {
    return <YoutubeRecentBroadcasts station={station} />;
  }

  return <NoSegmentsMessage />;
}
